import React from 'react';
import ProductionSalesHybrid from './ProductionSalesHybrid';

export default function WalmartProductionSalesTest() {
  return (
    <ProductionSalesHybrid
      customerName="Walmart"
      customers={['WALMART', 'WALMART DOTCOM']}
      divisions={['10', '60', '77']}
      labels={['WALMART', 'WM BASICS', 'WM PLUS', 'RESORT', 'REPLEN', 'DOTCOM', 'RDSDC', 'DSV', 'YBM']}
      defaultExcludeLabels={['RESORT']}
      excludedPrograms={[]}
    />
  );
}
